import React, { useEffect } from 'react'
import { Link, useNavigate } from "react-router-dom";
import { Alert, Card, CardBody, Col, Container, Row } from 'reactstrap';
import logoDark from "../../assets/images/logo-dark.png";
import logoLight from "../../assets/images/logo-dark.png";

const Register = props => {
  document.title = "";

  const navigate = useNavigate();

  // إعادة توجيه فورية لصفحة تسجيل الدخول
  useEffect(() => {
    navigate("/login");
  }, [navigate]);

  return (
    <React.Fragment>
      <div className="account-pages my-5 pt-sm-5">
        <Container>
          <Row className="justify-content-center">
            <Col md={8} lg={6} xl={5}>
              <Card className="overflow-hidden">
                <CardBody className="pt-0">
                  <h3 className="text-center mt-5 mb-4">
                    <Link to="/login" className="d-block auth-logo">
                      <img src={logoDark} alt="" height="30" className="auth-logo-dark" />
                      <img src={logoLight} alt="" height="30" className="auth-logo-light" />
                    </Link>
                  </h3>
                  <div className="p-3 text-center">
                    <Alert color="warning">
                      <h4 className="alert-heading">التسجيل معطل!</h4>
                      <p>التسجيل من الخارج غير متاح. يرجى التواصل مع الإدارة للحصول على حساب.</p>
                      <hr />
                      <Link to="/login" className="btn btn-primary">
                        العودة لتسجيل الدخول
                      </Link>
                    </Alert>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
};

export default Register;